import React, { useState } from 'react'
import { color } from '../../theme/color'

import { Text } from '../text'
import { Medal } from '../medal'
// @ts-ignore
import BoosterIcon from './booster-icon.svg'

const areEqual = (prevProps: any, nextProps: any) => {
  const { quiz } = nextProps
  const { quiz: prevQuiz } = prevProps

  /*if the props are equal, it won't update*/
  let _areEqual = quiz.quiz_id === prevQuiz.quiz_id
  if (_areEqual && quiz.result_id) _areEqual = quiz.result_id === prevQuiz.result_id
  if (_areEqual && quiz.completed_attempts)
    _areEqual = quiz.completed_attempts === prevQuiz.completed_attempts
  if (_areEqual && quiz.knowledge_pct) _areEqual = quiz.knowledge_pct === prevQuiz.knowledge_pct

  return _areEqual
}

export const KnowledgeBooster = React.memo((props: any) => {
  const {
    due,
    quiz,
    onPress,
    isReinforcement,
    imgSource,
    style,
    parentTopicLocked,
    maxAttempts,
    history,
  } = props

  // TODO style differently when disabled. Might need to be a button
  const disabled = quiz?.is_locked || parentTopicLocked

  return (
    <div
      style={{
        flex: 1,
        justifyContent: 'center',
        borderRadius: 12,
        backgroundColor: color.white,
        ...style,
      }}
      onClick={onPress}
    >
      <KnowledgeBoosterContent
        history={history}
        maxAttempts={maxAttempts}
        due={due}
        quiz={quiz}
        imgSource={imgSource ? imgSource : null}
        isReinforcement={isReinforcement}
      />
    </div>
  )
}, areEqual)

const KnowledgeBoosterContent = React.memo((props: any) => {
  const { quiz } = props

  let unlockTime = 0

  if (quiz?.is_locked) {
    const now = new Date()
    const unlocksAt = new Date(quiz.unlocks_at)

    const differenceMs = unlocksAt.getTime() - now.getTime()
    unlockTime = Math.ceil(differenceMs / 1000 / 60)
  }

  return (
    <div
      style={{
        display: 'flex',
        backgroundColor: color.white,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 20,
        height: 84,
        paddingLeft: 28,
        paddingRight: 21,
        marginBottom: 4,
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          paddingTop: 24,
          paddingBottom: 24,
        }}
      >
        <Text variant="titleEmphasized" tx="Quiz.booster" />
        <Text tx="Quiz.boosterSubtitle" variant="body2" style={{ opacity: 0 }} />
      </div>

      <div>
        <BoosterIcon />
      </div>
    </div>
  )
})
